// routes/ProtectedRoute.jsx
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { extractAllowedUrls } from "./utils/extractAllowedUrls";

// 👇 Add paths that should always be allowed (manually skipped from 403)
const manuallyAllowedPaths = [
  "/password-change",
  "/my-profile",
  "/failed",
  "/successful",
  "/self-form-sign",
  "/cancelled",
  "/pdfprepare",
  "/preview",
  "/pending",
  "/statusupdate",
  "/bulkstatusupdate",
  "/bulkcancel",
  "/ekyc-info",
  "/view-pdf",
  "/start-template-sign",
  "/new-form-sign",
  "/new-storage-plan",
  "/package-distribute",
  "/purchase-history",
  "/pending-purchase",
  "/signing-active-list",
  "/signing-start-sign",
  "/users-list",
  "/user",
  "/user-pages-error-500",
];

export const ProtectedRoute = ({
  component: Component,
  showPassError,
  path,
  ...rest
}) => {
  const loggedIn = localStorage.getItem("loggedIn") === "true";
  const profile = JSON.parse(localStorage.getItem("myProfile") || "{}");
  const allowedUrls = extractAllowedUrls(profile?.allowedFeatureList || []);

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        const currentPath = props.location.pathname;

        const isAllowed =
          allowedUrls.includes(currentPath) ||
          manuallyAllowedPaths.includes(currentPath);

        if (!loggedIn) {
          return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
        }

        if (showPassError) {
          return <Redirect to={{ pathname: "/password-change", state: { from: props.location } }} />;
        }

        if (!isAllowed) {
          return <Redirect to={{ pathname: "/unauthorized", state: { from: props.location } }} />;
        }

        return <Component {...props} />;
      }}
    />
  );
};